var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFindReplace = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.333,
  d: "M9.333 2.667A.667.667 0 0 1 10 2M10 6.667A.667.667 0 0 1 9.333 6M14 2.667A.667.667 0 0 0 13.333 2M14 6a.667.667 0 0 1-.667.667M2 4.667l2 2 2-2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.333,
  d: "M4 6.667V3.333A1.333 1.333 0 0 1 5.333 2h1.334M6 9.333H2.667A.667.667 0 0 0 2 10v3.333c0 .368.298.667.667.667H6a.667.667 0 0 0 .667-.667V10A.667.667 0 0 0 6 9.333"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFindReplace);
export default ForwardRef;